var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionFee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3683 7.14865L22.7504 5.04235V5L22.713 5.02229L22.6755 5V5.04235L19.0576 7.14865L15.4421 5.04235V5L15.4046 5.02229L15.3671 5V5.04235L11.7493 7.14865L8.05878 5V33L11.7493 30.8513L15.3671 32.9554V33L15.4046 32.9777L15.4421 33V32.9554L19.0576 30.8513L22.6755 32.9554V33L22.713 32.9777L22.7504 33V32.9554L26.3683 30.8513L30.0588 33V5L26.3683 7.14865Z",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1603 12.2C17.5035 12.2 16.1603 13.2745 16.1603 14.6C16.1603 15.9255 17.1603 17 19.1603 17C21.1603 17 22.1603 18.0745 22.1603 19.4C22.1603 20.7255 20.8172 21.8 19.1604 21.8M19.1603 12.2C20.2708 12.2 21.2403 12.6826 21.759 13.4M19.1603 12.2V11M19.1604 21.8L19.1603 23M19.1604 21.8C18.0499 21.8 17.0804 21.3174 16.5617 20.6",
    stroke: "#0E5CF4",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0588 26L25.0588 26",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionFee);
export default __webpack_public_path__ + "static/media/ic-transaction-fee.8fa669bb00171c8b22144a0c79515f45.svg";
export { ForwardRef as ReactComponent };